(function () {
  'use strict';

  function hydrateMediaModal(opener) {
    var selector = opener && opener.getAttribute('data-modal');
    var modal = selector && document.querySelector(selector);
    if (!modal || modal.hasAttribute('data-soothee-hydrated')) return;

    var target = modal.querySelector('[data-soothee-modal-content]');
    var template = modal.querySelector('template[data-soothee-modal-template]');
    if (!target || !template) return;

    var fragment = template.content.cloneNode(true);
    var wrapper = fragment.querySelector('[data-soothee-modal-fragment]');
    if (wrapper) {
      while (wrapper.firstChild) target.appendChild(wrapper.firstChild);
    } else {
      target.appendChild(fragment);
    }
    modal.setAttribute('data-soothee-hydrated', 'true');
  }

  function parkWriteReviewImage(root) {
    var image = root.querySelector && root.querySelector('.jdgm-write-review-modal__product-image img[src]');
    if (!image || image.hasAttribute('data-soothee-review-src')) return;

    image.setAttribute('data-soothee-review-src', image.getAttribute('src'));
    image.removeAttribute('src');
    image.loading = 'lazy';
    image.decoding = 'async';
  }

  function prepareBelowFoldImages(root) {
    var images = root.querySelectorAll && root.querySelectorAll('.jdgm-review-widget img, .jdgm-carousel-wrapper img');
    if (!images) return;
    images.forEach(function (image) {
      image.loading = 'lazy';
      image.decoding = 'async';
      if (!image.hasAttribute('fetchpriority')) image.setAttribute('fetchpriority', 'low');
    });
  }

  document.addEventListener('click', function (event) {
    var opener = event.target.closest('modal-opener[data-modal^="#ProductModal-"]');
    if (opener) hydrateMediaModal(opener);

    if (event.target.closest('.jdgm-write-rev-link, [data-judgeme-write-review]')) {
      requestAnimationFrame(function () {
        parkWriteReviewImage(document);
        var image = document.querySelector('.jdgm-write-review-modal__product-image img[data-soothee-review-src]');
        if (image && !image.getAttribute('src')) image.src = image.getAttribute('data-soothee-review-src');
      });
    }
  }, true);

  function start() {
    var deferredSections = Array.from(document.querySelectorAll('[data-soothee-deferred-app-section]'));
    var judgeMeFallbackMs = null;
    var manifestRequests = Object.create(null);
    var judgeMeStartedAt = performance.now();
    var judgeMeReason = null;
    var judgeMeRetryTimers = new WeakMap();

    function loadJudgeMeManifestCss(baseUrl, entryKey) {
      // The extension base URL is versioned. Reuse its cacheable manifest.
      var manifestUrl = baseUrl + 'manifest.json';
      if (!manifestRequests[manifestUrl]) manifestRequests[manifestUrl] = fetch(manifestUrl)
        .then(function (response) {
          if (!response.ok) throw new Error('Judge.me manifest request failed');
          return response.json();
        }).catch(function (error) { delete manifestRequests[manifestUrl]; throw error; });
      return manifestRequests[manifestUrl].then(function (manifest) {
          var visited = {};

          function loadEntry(key) {
            if (!key || visited[key]) return;
            visited[key] = true;
            var entry = manifest[key];
            if (!entry) return;

            (entry.css || []).forEach(function (file) {
              var href = baseUrl + file;
              if (document.querySelector('link[href="' + href + '"]')) return;
              var link = document.createElement('link');
              link.rel = 'stylesheet';
              link.href = href;
              document.head.appendChild(link);
            });
            (entry.imports || []).forEach(loadEntry);
          }

          loadEntry(entryKey);
        });
    }

    function initializeJudgeMe(section) {
      var container = section.querySelector('.jdgm-widget[data-entry-point]');
      var baseUrl = window.jdgm && window.jdgm.CDN_BASE_URL;
      if (!container || !baseUrl) return false;
      if (container.hasAttribute('data-v-app') || container.hasAttribute('data-soothee-judgeme-module-requested')) {
        return true;
      }

      container.setAttribute('data-soothee-judgeme-module-requested', 'true');
      var entryPoint = container.getAttribute('data-entry-point');
      var entryKey = container.getAttribute('data-entry-key');

      loadJudgeMeManifestCss(baseUrl, entryKey).catch(function () {
        return null;
      }).finally(function () {
        if (document.querySelector('script[data-soothee-judgeme-entry="' + entryPoint + '"]')) return;
        var script = document.createElement('script');
        script.type = 'module';
        script.src = baseUrl + entryPoint;
        script.setAttribute('data-soothee-judgeme-entry', entryPoint);
        document.head.appendChild(script);
      });
      return true;
    }

    function initializeJudgeMeWhenReady(section, attempt) {
      if (initializeJudgeMe(section) || attempt >= 40) return;
      clearTimeout(judgeMeRetryTimers.get(section));
      judgeMeRetryTimers.set(section, setTimeout(function () {
        initializeJudgeMeWhenReady(section, attempt + 1);
      }, 250));
    }

    function activateInlineScripts(section) {
      section.querySelectorAll('script').forEach(function (parkedScript) {
        var activeScript = document.createElement('script');
        Array.from(parkedScript.attributes).forEach(function (attribute) {
          activeScript.setAttribute(attribute.name, attribute.value);
        });
        activeScript.textContent = parkedScript.textContent;
        parkedScript.replaceWith(activeScript);
      });
    }

    function hydrate(section, reason) {
      if (section.hasAttribute('data-soothee-app-hydrated')) return;
      var template = section.querySelector('template[data-soothee-deferred-app-template]');
      if (!template) return;
      section.appendChild(template.content.cloneNode(true));
      template.remove();
      section.setAttribute('data-soothee-app-hydrated', 'true');
      section.setAttribute('data-soothee-app-hydration-reason', reason);
      section.removeAttribute('aria-busy');
      if (section.hasAttribute('data-soothee-inline-review')) section.style.minHeight = '';
      judgeMeReason = judgeMeReason || reason;
      document.documentElement.setAttribute('data-soothee-judgeme-reason', judgeMeReason);
      document.documentElement.setAttribute(
        'data-soothee-judgeme-ms',
        String(Math.round(performance.now() - judgeMeStartedAt))
      );
      activateInlineScripts(section);
      prepareBelowFoldImages(section);
      initializeJudgeMeWhenReady(section, 0);
    }

    function hydrateAll(reason) {
      deferredSections.forEach(function (section) {
        hydrate(section, reason);
      });
    }

    if (!('IntersectionObserver' in window)) {
      hydrateAll('intersection-observer-unavailable');
    } else if (deferredSections.length) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          observer.unobserve(entry.target);
          hydrate(entry.target, 'near-viewport');
        });
      }, { rootMargin: '800px 0px', threshold: 0.01 });

      var inlineObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          inlineObserver.unobserve(entry.target);
          hydrate(entry.target, 'inline-review-near-viewport');
        });
      }, { rootMargin: '200px 0px', threshold: 0.01 });

      deferredSections.forEach(function (section) {
        if (section.hasAttribute('data-soothee-app-observer-ready')) return;
        section.setAttribute('data-soothee-app-observer-ready', 'true');
        (section.hasAttribute('data-soothee-inline-review') ? inlineObserver : observer).observe(section);
      });
    }

    function onReviewIntent(event) {
      var target = event.target.closest('.jdgm-prev-badge, a[href*="judgeme"], a[href*="reviews"], [data-judgeme-write-review]');
      if (target) hydrateAll('review-intent');
    }
    document.addEventListener('click', onReviewIntent, true);
    document.addEventListener('focusin', onReviewIntent);
    if (/judgeme|reviews/.test(window.location.hash)) hydrateAll('review-anchor');
    window.addEventListener('hashchange', function () {
      if (/judgeme|reviews/.test(window.location.hash)) hydrateAll('review-anchor');
    });

    window.SootheeJudgeMeDeferred = {
      hydrate: hydrateAll,
      getState: function () {
        return {
          reason: judgeMeReason,
          elapsedMs: Math.round(performance.now() - judgeMeStartedAt),
          loaderReady: Boolean(window.jdgm && typeof window.jdgm.initializeWidgets === 'function'),
          hydratedSections: deferredSections.filter(function (section) {
            return section.hasAttribute('data-soothee-app-hydrated');
          }).length,
          fallbackDeadlineMs: judgeMeFallbackMs
        };
      }
    };

    parkWriteReviewImage(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
